import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { MultiProductUpgradeModalProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyMultiProductUpgradeModal = lazy(
	() => import(/* webpackChunkName: "async-multi-product-upgrade" */ './main'),
);

export const AsyncMultiProductUpgradeModal = (props: MultiProductUpgradeModalProps) => (
	<JSErrorBoundary id="multi-product-upgrade-modal" packageName="jira-experiments">
		<LazyMultiProductUpgradeModal {...props} />
	</JSErrorBoundary>
);
